import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PlanForm, PlansTable } from "../../components";

export const PlansTab = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: "flex", gap: 3, p: 3, backgroundColor: "#f5f5f5", flex: 1, overflow: "hidden" }}>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1, minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary">
          {t("videoLibrary.plansTabNote")}
        </Typography>
        <PlanForm />
      </Box>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>
        <PlansTable />
      </Box>
    </Box>
  );
};
